import { useQuery } from "@tanstack/react-query";
import { getAdverts } from "./services";

export const useGetAdvertsQuery = (locale: string) =>
  useQuery({
    queryKey: ["adverts", locale],
    queryFn: () => getAdverts(locale),
  });
